import { call, put, select, takeLatest, fork } from 'redux-saga/effects';

import {
  updateProvisionalOfferSuccess,
  updateProvisionalOfferFailure,
  UPDATE_PROVISIONAL_OFFER_REQUEST,
} from '../actions/updateProvisionalOfferActions';
import ProvisionalOfferAPI from '../api/ProvisionalOfferAPI';
import { accessTokenSelector } from '../reducers/selectors';

import { manageAPIError } from './helpers/errorHelper';

function* provisionalOfferUpdateWatcher() {
  yield takeLatest(UPDATE_PROVISIONAL_OFFER_REQUEST, provisionalOfferUpdateWorker);
}

function* provisionalOfferUpdateWorker(action) {
  const { params } = action;
  try {
    const accessToken = yield select(accessTokenSelector);
    const payload = yield call(ProvisionalOfferAPI.updateProvisionalOfferFor, params, accessToken);
    yield put(updateProvisionalOfferSuccess(payload));
  } catch (error) {
    yield put(updateProvisionalOfferFailure(error));
    yield fork(manageAPIError, { ...error, action, useFallbackError: false });
  }
}

export { provisionalOfferUpdateWorker };
export default provisionalOfferUpdateWatcher;
